import { de } from '@/i18n/de';
import { problemText } from '@/i18n/messages';
import { ApiOffline, ApiProblem } from './problem';

/** Klartext für eine gescheiterte Handlung (Hinweis oder Fehlerkarte); nie Rohtext oder Stacktrace. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiProblem) {
    return error.message;
  }
  return error instanceof ApiOffline ? de.problem.offline : problemText('internal');
}
